export const RankingTypes = {
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    ALL_TIME_DAILY: 'ALL_TIME_DAILY'
}
